<template>
  <div>
    <VRow class="align-center mt-15">
      <div>
        <VIcon class="mx-5" large>mdi-store</VIcon>
      </div>
      <div>
        <h1>{{business.shop_name}}</h1>
      </div>
      <div>
        <h1>
          <span class="ml-6" style="color: silver">{{ hoozies }}</span>
        </h1>
      </div>
    </VRow>
    <VRow class="ml-5 my-15">
      <nav class="navbar">
        <VRow>
          <div
            class="mr-10 mt-3"
            v-for="item in businessItems"
            :key="item.title"
          >
            <router-link
              :class="item.active ? 'nav_item_active' : 'nav_item_inactive'"
              :to="item.path"
              @click="item.active = !item.active"
            >
              {{ item.title }}
            </router-link>
          </div>
        </VRow>
      </nav>
    </VRow>
  </div>
</template>

<script>
export default {
    props: {
    business: {
      type: Object,
      require: false,
    },
  },
  components: {},
  data: () => ({
    selectedItem: 1,
    hoozies: null,
    businessItems: [
      { path: "/business/edit/1/info", title: "Information", active: true },
      { path: "/business/edit/1/products", title: "Promotions", active: false },
      { path: "/business/edit/1/queue", title: "Pending", active: false },
      { path: "/business/edit/1/transactions", title: "Transactions", active: false },
      { path: "/business/edit/1/rating", title: "Rating", active: false },
      { path: "/business/edit/1/transfer", title: "Transfer Hoozies", active: false },
      { path: "/business/edit/81363a22-c416-5db3-b541-3bda92573373/events", title: "Edit business top tab", active: false },
    ],
  }),
  mounted() {
    let balance = this.business.balance.total
    if (balance % 1 == 0) {
        this.hoozies = "• " + balance + " Hoozies";
      } else {
        this.hoozies = "• " + parseFloat(balance).toFixed(2) + " Hoozies";
      }
  },
  watch:{
    '$route.path': {
        handler: function(path) {
           for(let i = 0; i < this.businessItems.length; i++) {
             if(path == this.businessItems[i].path) {
               this.businessItems[i].active = true
             }
             else {
               this.businessItems[i].active = false
             }
           }
        },
        deep: true,
        immediate: true
      }
  },
  methods: {
    selectItem(item) {
      this.selectedItem = item.path;
      for (let i = 0; i < this.businessItems.length; i++) {
        if (this.businessItems[i] != item) {
          this.businessItems[i].active = false;
        } else {
          this.businessItems[i].active = true;
        }
      }
    },
    updateBusiness(business) {
      this.business = business
    }
  },
};
</script>

<style scoped>
.nav_item_active,
.nav_item_inactive:hover {
  font-weight: 600;
  font-size: 20px;
  line-height: 23px;
  color: #72AFE7;
  text-decoration: none;
}
.nav_item_inactive {
  font-weight: 500;
  font-size: 20px;
  line-height: 23px;
  color: #6b444a;
  text-decoration: none;
}
</style>